import type { Direction, TrackShape } from '@config'

export const EXTERNAL_EDGE_LENGTH = 0.001

export const DIRS: Record<Direction, { dx: number; dy: number; opposite: Direction }> = {
  N: { dx: 0, dy: -1, opposite: 'S' },
  E: { dx: 1, dy: 0, opposite: 'W' },
  S: { dx: 0, dy: 1, opposite: 'N' },
  W: { dx: -1, dy: 0, opposite: 'E' },
}

export const SHAPES: Record<TrackShape, { ports: Direction[]; links: [Direction, Direction][] }> = {
  N: { ports: ['S'], links: [] },
  S: { ports: ['N'], links: [] },
  E: { ports: ['W'], links: [] },
  W: { ports: ['E'], links: [] },
  NS: { ports: ['N', 'S'], links: [['N', 'S']] },
  WE: { ports: ['W', 'E'], links: [['W', 'E']] },
  NE: { ports: ['N', 'E'], links: [['N', 'E']] },
  NW: { ports: ['N', 'W'], links: [['N', 'W']] },
  SE: { ports: ['S', 'E'], links: [['S', 'E']] },
  SW: { ports: ['S', 'W'], links: [['S', 'W']] },
}

// Physics simulation thresholds
export const EPSILON = 0.0001
export const VELOCITY_EPSILON = 0.001
export const CONSTRAINT_SCALE_THRESHOLD = 0.9999

// Absorbs float drift on contact checks: coupled vehicles rest at exactly the coupling threshold
export const COLLISION_TOLERANCE = 1e-6

// Upper bound on edge traversals per move, guards against runaway loops on malformed input
export const MAX_EDGE_TRAVERSALS = 1024

// Physical gap between coupled vehicle ends (coupler mechanism length, also used for detection)
export const COUPLING_GAP = 0.2

// Fraction of velocity retained on coupling impact
export const COUPLING_IMPACT_FACTOR = 0.5

// World-space offset from cell center to each port opening
export const PORT_OFFSETS: Record<string, { x: number; z: number }> = {
  N: { x: 0, z: -0.5 },
  S: { x: 0, z: 0.5 },
  E: { x: 0.5, z: 0 },
  W: { x: -0.5, z: 0 },
}

export const LOCO_DEFAULT_SPEED = 5

// Arc length of a 90-degree quadratic Bézier curve with port offsets at ±0.5:
// integral from 0 to 1 of |P'(t)| dt = sqrt(2) * (ln(1+sqrt(2)) + sqrt(2)) / 4
export const BEZIER_90_ARC_LENGTH = (Math.sqrt(2) * (Math.log(1 + Math.sqrt(2)) + Math.sqrt(2))) / 4
